<span *ngIf="hint" class="d-block mb-2">{{ hint }}</span>
<button
    [className]="
        [classes?.join(' '), 'btn', 'btn-secondary', 'app-button'].join(' ')
    "
    [disabled]="!!disabled"
    (click)="onClick(actionCallback)"
    [ngbTooltip]="tip"
>
    <!-- {{ label }} -->
    <span [innerHTML]="label"></span>
    
</button>
<ng-container *ngIf="!actionCallback">
    <h6>Debugg purpose only:</h6>
    <h3>NOT CALLBACK FUNCTION</h3>
</ng-container>
